var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusAgreementSectionInnerLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 101.5,
    viewBox: "0 0 101.5 101.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money-bill-trend-up-solid",
    d: "M93.313,1.863A6.838,6.838,0,0,1,94.68,3.905a6.052,6.052,0,0,1,.476,2.419v.02h0V25.375a6.344,6.344,0,1,1-12.687,0V21.668L61.574,42.543a6.357,6.357,0,0,1-8.624.337l-18.06-15.5-18.08,15.5a6.341,6.341,0,1,1-8.247-9.635l22.2-19.031a6.344,6.344,0,0,1,8.267,0L56.777,29.419,73.488,12.688H69.781A6.344,6.344,0,0,1,69.781,0H88.813a6.391,6.391,0,0,1,4.48,1.844l.02.02ZM0,60.266A9.518,9.518,0,0,1,9.516,50.75H91.984a9.518,9.518,0,0,1,9.516,9.516V91.984a9.518,9.518,0,0,1-9.516,9.516H9.516A9.518,9.518,0,0,1,0,91.984Zm9.516,22.2v9.516h9.516A9.518,9.518,0,0,0,9.516,82.469Zm9.516-22.2H9.516v9.516A9.518,9.518,0,0,0,19.031,60.266Zm72.953,22.2a9.518,9.518,0,0,0-9.516,9.516h9.516Zm-9.516-22.2a9.518,9.518,0,0,0,9.516,9.516V60.266ZM63.438,76.125A12.688,12.688,0,1,0,50.75,88.813,12.688,12.688,0,0,0,63.438,76.125Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusAgreementSectionInnerLeftIcon);
export default __webpack_public_path__ + "static/media/bonus-agreement-section-inner-left-icon.1d65bfb3262daeec5a64927654a3a7fe.svg";
export { ForwardRef as ReactComponent };